var _path, _path2, _path3, _path4, _mask, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessmentFailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 62,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3f2dd",
    d: "M10.18 13.738h22.516c6.415 0 11.615 5.2 11.615 11.615v19.23c0 9.426-7.64 17.066-17.065 17.066S10.18 54.01 10.18 44.584z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7cc5b",
    d: "M10.18 13.738h27.131a7 7 0 0 1 7 7v8.326h-34.13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1212",
    strokeWidth: 6,
    d: "M2.121 7.872 6.03 11.78v5.712l4.21 3.909M52.098 7.872l-3.909 3.908v5.712l-4.209 3.909M15.424 1.773l3.163 4.533-1 5.624 3.459 4.585M41.919 1.773l-3.267 4.459.87 5.645-3.565 4.504"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b1b",
    d: "M15.907 33.871h6.94v1.928h-6.94zM32.895 33.871h6.94v1.928h-6.94z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.897 51.37a6.345 6.345 0 1 0-12.69 0h1.906a4.439 4.439 0 0 1 8.877 0z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#efcfc3",
    strokeWidth: 6,
    d: "M33.897 51.37a6.345 6.345 0 1 0-12.69 0h1.906a4.439 4.439 0 0 1 8.877 0z",
    mask: "url(#a)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd18e",
    fillOpacity: 0.4,
    d: "M27.246 13.738h5.45c6.415 0 11.615 5.2 11.615 11.615v19.231c0 9.425-7.64 17.065-17.065 17.065z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentFailIcon);
export default __webpack_public_path__ + "static/media/assessment-fail-icon.266d113d3277f502854c6020e9fec689.svg";
export { ForwardRef as ReactComponent };